import { useEffect, useState } from "react";
import axios from "axios";
import { ChevronDown, Info } from "lucide-react";
import { InfoTip } from "@/components/exec/InfoTip";

const API = process.env.REACT_APP_BACKEND_URL;
export const RULES = [
  ["Not in Gingr", "Open", "No Gingr account yet"],
  ["Account created after the lead, $0, nothing booked", "Qualified (HOT)", "New customer · account created"],
  ["Account + only a tour/evaluation booked, $0", "Qualified", "New customer · tour booked"],
  ["Account + stay booked (upcoming or completed since lead) + $0 paid", "Qualified", "Booked · no deposit yet"],
  ["Account + stay booked + more than $0 paid", "Converted", "Converted · $X paid"],
  ["Account existed well before the lead AND paid before", "Existing Customer", "Existing customer"],
];

const Table = () => (
  <table className="w-full table-fixed text-xs"><colgroup><col className="w-[46%]" /><col className="w-[22%]" /><col className="w-[32%]" /></colgroup>
    <thead><tr className="text-left text-gray-500"><th className="py-1 pr-2">Situation in Gingr</th><th className="pr-2">Status</th><th>Label</th></tr></thead>
    <tbody>{RULES.map((r) => <tr key={r[0]} className="border-t border-gray-100"><td className="py-1 pr-2 align-top">{r[0]}</td><td className="pr-2 font-semibold align-top">{r[1]}</td><td className="align-top">{r[2]}</td></tr>)}</tbody>
  </table>
);

// Leads page: collapsible "How lead status works" reminder.
export const LeadStatusRulesInfo = () => {
  const [open, setOpen] = useState(() => localStorage.getItem("leadRulesOpen") === "1");
  const toggle = () => { localStorage.setItem("leadRulesOpen", open ? "0" : "1"); setOpen(!open); };
  return (
    <div className="rounded-xl border border-indigo-100 bg-indigo-50/60 px-4 py-2.5" data-testid="lead-status-rules">
      <button onClick={toggle} className="flex w-full items-center gap-2 text-sm font-semibold text-indigo-900" data-testid="lead-status-rules-toggle">
        <Info className="w-4 h-4" />How lead status works (checked against Gingr automatically)
        <ChevronDown className={`ml-auto w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-2 overflow-x-auto"><Table />
        <p className="text-[11px] text-gray-500 mt-1.5">Converted = a stay booked + more than $0 paid (deposit or invoice). Applies to leads from Oct 9, 2026 on.</p></div>}
    </div>
  );
};

// Lead page: Gingr stage header for the POS match box (replaces the old always-"Existing / Converted" header).
export const GingrStageHeader = ({ leadId, status }) => {
  const [c, setC] = useState(null);
  useEffect(() => { axios.get(`${API}/api/leads/${leadId}/gingr-stage`).then((r) => setC(r.data)).catch(() => setC({})); }, [leadId]);
  const conv = status === "converted";
  return (
    <div className="flex items-center justify-between gap-2 mb-3" data-testid="gingr-stage-header">
      <div className="font-bold text-green-900 text-lg flex items-center gap-1.5" data-testid="gingr-stage-label">
        {c ? (c.label || "In Gingr") : "Checking Gingr…"}
        <InfoTip title="How lead status works" tid="gingr-stage-info" wide><Table /></InfoTip>
      </div>
      <span className={`text-xs px-3 py-1 rounded-full font-semibold ${conv ? "bg-green-600 text-white" : "bg-amber-100 text-amber-800"}`} data-testid="gingr-stage-status">
        {conv ? "CONVERTED" : (status || "").replace("_", " ").toUpperCase()}</span>
    </div>
  );
};
